document.addEventListener('DOMContentLoaded', function () {
  // === Modal Logic ===
  var modal = document.getElementById('sizeChartModal');
  var closeModal = document.getElementsByClassName('size-chart-modal-close')[0];
  var sizeChartBtn = document.getElementById('sizeChartBtn');

  if (sizeChartBtn && modal) {
    sizeChartBtn.addEventListener('click', function () {
      modal.style.display = "flex";
      document.body.classList.add('overflow-hidden'); 
    });
  }

  if (closeModal && modal) {
    closeModal.addEventListener('click', function () {
      modal.style.display = "none";
      document.body.classList.remove('overflow-hidden');
    });
  }

  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.style.display = "none";
      document.body.classList.remove('overflow-hidden'); 
    }
  });

  // === Mobile Slider Logic ===
  const sizesContainer = document.querySelector('.table.mobile .sizes');
  const sizeElements = sizesContainer?.children;
  const prevBtn = document.querySelector('.prev-btn');
  const nextBtn = document.querySelector('.next-btn');

  if (!sizesContainer || !sizeElements || sizeElements.length === 0) {
    console.warn('Sizes carousel elements not found.');
    return;
  }

  const totalSizes = sizeElements.length;
  let current = 1;

  function updateTransform() {
    sizesContainer.style.transform = `translateX(calc(${(current - 1)} * -40.8vw))`;
  }

  function getLabelById(id) {
    const el = document.querySelector(`[data-size-id="${id}"] .sizes-label`);
    return el ? el.textContent.trim() : '';
  }

  function prevSize(el) {
    if (current > 1) {
      current--;
    } else {
      current = totalSizes;
    }

    updateTransform();

    const prevLabel = current === 1 ? getLabelById(totalSizes) : getLabelById(current - 1);
    const nextLabel = current === totalSizes ? getLabelById(1) : getLabelById(current + 1);

    if (el?.querySelector('.label')) {
      el.querySelector('.label').textContent = prevLabel;
    }

    if (nextBtn?.querySelector('.label')) {
      nextBtn.querySelector('.label').textContent = nextLabel;
    }
  }

  function nextSize(el) {    
    if (current < totalSizes) {
      current++;
    } else {
      current = 1;
    }

    updateTransform();

    const nextLabel = current === totalSizes ? getLabelById(1) : getLabelById(current + 1);
    const prevLabel = current === 1 ? getLabelById(totalSizes) : getLabelById(current - 1);

    if (el?.querySelector('.label')) {
      el.querySelector('.label').textContent = nextLabel;
    }

    if (prevBtn?.querySelector('.label')) {
      prevBtn.querySelector('.label').textContent = prevLabel;
    }
  }

  // Attach event listeners
  prevBtn?.addEventListener('click', function () {
    prevSize(this);
  });

  nextBtn?.addEventListener('click', function () {
    nextSize(this);
  });

  // Optional: Initialize button labels on load
  if (prevBtn?.querySelector('.label')) {
    prevBtn.querySelector('.label').textContent = getLabelById(totalSizes);
  }
  if (nextBtn?.querySelector('.label')) {
    nextBtn.querySelector('.label').textContent = getLabelById(current + 1);
  }

   document.addEventListener('click', function (e) {
    const sizeChartBtn = e.target.closest('#sizeChartBtn');
    if (!sizeChartBtn) return;

    const modal = document.getElementById('sizeChartModal');
    if (modal) {
      modal.style.display = 'flex';
      document.body.classList.add('overflow-hidden'); // optional scroll lock
      //console.log('Opening modal');
    }
  });
  
});
